import HorizontalSlider from './horizontal-slider';

let timelineSlider = () => {

    let module = {},

        init = () => {

            let slider = new HorizontalSlider('#timelineSlider', {
                slideBy: 1,
                onChanged: function (index) {
                    $('.timeline-picture img').removeClass('active').eq(index).addClass('active');
                }
            });

            $('.timeline-item').find('.bullet, .item-text').on('click', (e) => {
                let sliderItemIndex = $(e.currentTarget).parents('.timeline-item').index();
                slider.goTo(sliderItemIndex);
            })

        };

    module.init = init;

    return module;

};

export default timelineSlider();